import type { MenuSection } from "./types/MenuSection"

export const hasItems = (section: MenuSection): boolean => section.length > 0
